import React from 'react';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
import { loginRequest } from 'authConfig';

type PrivateRouteProps = {
    children: any;
}

const PrivateRoute = ({ children }: PrivateRouteProps) => {
    
    return (
        <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={loginRequest}>
            {children}
        </MsalAuthenticationTemplate>
    );
}

export default PrivateRoute